"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("../utils/utils");

var _units = require("./units");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var color = {
  paper: '#1C1C1C',
  action: '#82D3F7',
  text: '#DEDEDE',
  disabled: '#747474',
  structure: '#000000',
  warning: '#ECC27D',
  hover: '#002652',
  hoverText: '#3D97FF',
  focus: '#FFC300',
  panel: 'rgba(28,28,28,0.8)',
  highlight: 'rgba(255,255,255,0.05)',
  lavender: '#9DA1E2',
  petunia: '#EA96C0',
  navy: '#81D0EC',
  poppy: '#FFA38C',
  larkspur: '#5574FF',
  daffodil: '#F9FA93'
};
var graphPaperSVG = (0, _utils.encodeSVG)("<svg width=\"4\" height=\"4\" viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"15\" height=\"15\" fill=\"".concat(color.paper, "\"></rect>\n<path fill=\"").concat(color.structure, "\" d=\"M8,14 L8,15 L7,15 L7,14 L8,14 Z M8,12 L8,13 L7,13 L7,12 L8,12 Z M8,4 L8,7 L11,7 L11,8 L8,8 L8,11 L7,11 L7,8 L4,8 L4,7 L7,7 L7,4 L8,4 Z M13,7 L13,8 L12,8 L12,7 L13,7 Z M15,7 L15,8 L14,8 L14,7 L15,7 Z M3,7 L3,8 L2,8 L2,7 L3,7 Z M1,7 L1,8 L0,8 L0,7 L1,7 Z M8,2 L8,3 L7,3 L7,2 L8,2 Z M8,0 L8,1 L7,1 L7,0 L8,0 Z\"></path>\n</svg>"));
var _default = {
  name: 'dark',
  color: color,
  globalSizes: _units.globalSizes,
  pattern: {
    disabled: "repeating-linear-gradient(45deg,".concat(color.structure, " 1px,transparent 2px,transparent 3px,").concat(color.structure, " 4px);"),
    error: "repeating-linear-gradient(45deg,".concat(color.warning, " 1px,transparent 2px,transparent 3px,").concat(color.warning, " 4px);"),
    graphPaper: "url('data:image/svg+xml,".concat(graphPaperSVG, "')")
  },
  font: {
    base: 16,
    size: Object.entries(_units.typography).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          options = _ref2[1];

      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, options.size));
    }, {}),
    family: 'Roboto, “Lucida Sans Unicode”, “Lucida Grande”, Tahoma, “Trebuchet MS”, Helvetica, Verdana, Geneva',
    weight: _units.weight
  },
  layer: {
    overlay: 9999,
    modal: 999,
    panels: 99,
    hovering: 9,
    normal: 0
  }
};
exports["default"] = _default;